export default __webpack_public_path__ + "static/media/JCB.8b467d9e.svg";